import { apiClient } from '@app/lib'
import { useSugarContext } from '@app/providers'
import { type SugarFindExpenditureResponse } from '@app/types'
import { useQuery } from '@tanstack/react-query'
import { isEmpty, omitBy } from 'lodash'
import { useSession } from 'next-auth/react'

export const useFindExpenditure = (params: {
  schoolYearId: string | null
  quarterId: string | null
  providerId?: string | null
}) => {
  const session = useSession()
  const sugar = useSugarContext()

  return useQuery({
    enabled:
      session.status === 'authenticated' &&
      !!params.schoolYearId &&
      !!params.quarterId &&
      (!sugar?.isProviderRequired || !!params.providerId),
    queryKey: [
      'expenditure',
      sugar?.isProviderRequired
        ? [params.schoolYearId, params.quarterId, params.providerId]
        : [params.schoolYearId, params.quarterId]
    ],
    queryFn: async () => {
      const { data } = await apiClient.get<SugarFindExpenditureResponse>('/api/expenditures/search', {
        params: omitBy(params, isEmpty)
      })

      return data
    }
  })
}
